<template>
  <div class="page-wrapper">
    <div class="page-title">
      <CIcon name="cil-user" /> User Analytics
    </div>

    <h1>COMING SOON</h1>

    <!-- <CCard>
      <CCardBody>
        <CRow>
          <CCol sm="12">
            <h4 id="traffic" class="card-title mb-0">Data Filters</h4>
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="3">
            <CCallout color="danger">
              <b>Select Time Interval</b>
              <CInputRadioGroup
                name="sourceTypeRadio"
                checked="month"
                :options="timeTypeRadio"
                :value.sync="selected.sourceType"
                @update:checked="updateSourceType"
              />
            </CCallout>
          </CCol>
          <CCol sm="9" v-if="selected.sourceType == 'month'">
              <CInput
                  label="Select any date from desired month"
                  type="date"
                  v-model="selected.date"
              />
          </CCol>
          <CCol sm="9" v-if="selected.sourceType == 'year'">
              <CInput
                  label="Select any date from desired year"
                  type="date"
                  v-model="selected.date"
              />
          </CCol>
          <CCol sm="3" v-if="selected.sourceType == 'range'">
              <CInput
                  label="Select Start Date"
                  type="date"
                  v-model="selected.startDate"
              />
          </CCol>
          <CCol sm="3" v-if="selected.sourceType == 'range'">
              <CInput
                  label="Select End Date"
                  type="date"
                  v-model="selected.endDate"
              />
          </CCol>
        </CRow>
      </CCardBody>   
      <CCardFooter class="text-center">
          <CButton type="submit" size="sm" color="danger mr-4" @click="reset()"><CIcon name="cil-reload"/> Reset Filters</CButton>
          
          <CButton type="submit" size="sm" color="primary ml-4" @click="apply()"><CIcon name="cil-check-circle"/> Apply Filters</CButton>
      </CCardFooter>   
    </CCard>

    <CRow>
      <CCol sm="6">
        <CCard>
          <CCardHeader>
            <h4 id="traffic" class="card-title mb-0">Top Users</h4>
            <div class="small text-muted">Based on total distance trekked</div>
          </CCardHeader>
          <CCardBody>
            
            <CDataTable
              style="max-height : 670px; overflow-y : scroll"
              class="mb-0 table-outline"
              hover
              :items="usersTrekWise"
              :fields="tableFieldsTrek"
              head-color="dark"
              no-sorting
            >
            
              <td slot="rank" slot-scope="{item}">
                <div>{{usersTrekWise.indexOf(item) + 1}}</div>
              </td>
              <td slot="user" slot-scope="{item}">
                <div>{{item.userinfo.firstname}} {{item.userinfo.lastname}}</div>
                <div class="small text-muted">
                  {{item.userinfo.phone}}
                </div>
              </td>
              <td slot="distance" slot-scope="{item}">
                <div>{{item.dist}} km</div>
              </td>
              <td slot="average" slot-scope="{item}">
                <div>{{item.avg_dist}} km</div>
              </td>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol sm="6">
        <CCard>
          <CCardHeader>
            <h4 id="traffic" class="card-title mb-0">Top Users</h4>
            <div class="small text-muted">Based on total sighting</div>
          </CCardHeader>
          <CCardBody>
            
            <CDataTable
              style="max-height : 670px; overflow-y : scroll"
              class="mb-0 table-outline"
              hover
              :items="usersSightingWise"
              :fields="tableFieldsSighting"
              head-color="dark"
              no-sorting
            >
              <td slot="rank" slot-scope="{item}">
                <div>{{usersSightingWise.indexOf(item) + 1}}</div>
              </td>
              <td slot="user" slot-scope="{item}">
                <div>{{item.userinfo.firstname}} {{item.userinfo.lastname}}</div>
                <div class="small text-muted">
                  {{item.userinfo.phone}}
                </div>
              </td>
              <td slot="sightings" slot-scope="{item}">
                <div>{{item.count}}</div>
              </td>
            </CDataTable>
          </CCardBody>
        </CCard>

      </CCol>
    </CRow>    -->

    
  </div>
</template>

<script>

import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import GridLoader from 'vue-spinner/src/GridLoader.vue'


import axios from 'axios';
import store from '../store';

export default {
  name: 'UserAnalytics',
  components: {
    PulseLoader,
    GridLoader
  },
  data () {
    return {
      baseURL : store.state.baseURL,
      selected: 'Month',
      usersSightingWise     : [],
      usersTrekWise : [],      

      loading : true,
      numberLoading : true,
      timeTypeRadio : [
        { value: 'month', label: 'Monthly Data' },
        { value: 'year',  label: 'Yearly Data' }
      ],
      tableFieldsTrek: [
        { key: 'rank' },
        { key: 'user' },
        { key: 'distance', _classes: 'text-center' },
        { key: 'average', _classes: 'text-center' }
      ],
      tableFieldsSighting: [
        { key: 'rank' },
        { key: 'user' },
        { key: 'sightings', _classes: 'text-center' }
      ],
      selected : {
          areaType : null,
          sourceType : 'month',
          date : null
      },
    }
  },
  mounted(){
    // this.getTrekWiseTopUser();
    // this.getSightingWiseTopUser();
  },
  methods: {
    updateSourceType(value, event){
      this.selected.sourceType = value;
    },
    reset(){
        window.location.reload();
    },
    apply(){
      var errors = "";

      if(errors != "")
      {
        this.$notify({
            group: 'notification',
            type : 'error',
            title: 'Important message',
            text: errors
        });
      }
      else{
        this.getTrekWiseTopUser();
        this.getSightingWiseTopUser();
      }
    },    
    getTrekWiseTopUser(){
      this.loading = true;
      axios({
          url : this.baseURL + "dashboard/analytics/topTen/trekWise",
          headers : {
              authorization : store.state.token
          },
          method : "POST",
          data : {
            date : this.selected.date,
            sourceType : this.selected.sourceType,
          }
      })
      .then(res => {
          if(res.data.status)
          {                
            this.usersTrekWise  = res.data.data;                  
          }
          else{
            this.$notify({
              group: 'notification',
              type : 'warn',
              title: 'Something went wrong',
              text: 'Error in loading data. Something went wrong!'
            });
          }
          this.loading = false;
      })
      .catch(err => {
          this.$notify({
            group: 'notification',
            type : 'warn',
            title: 'Important message',
            text: 'Error in loading data. Please check your internet connection!'
          });
          console.log(err);
          this.loading = false;
      });
    },
    getSightingWiseTopUser(){
      this.loading = true;
      axios({
          url : this.baseURL + "dashboard/analytics/topTen/sightingWise",
          headers : {
              authorization : store.state.token
          },
          method : "POST",
          data : {
            date : this.selected.date,
            sourceType : this.selected.sourceType,
          }
      })
      .then(res => {
          if(res.data.status)
          {                
            this.usersSightingWise  = res.data.data;                  
          }
          else{
            this.$notify({
              group: 'notification',
              type : 'warn',
              title: 'Something went wrong',
              text: 'Error in loading data. Something went wrong!'
            });
          }
          this.loading = false;
      })
      .catch(err => {
          this.$notify({
            group: 'notification',
            type : 'warn',
            title: 'Important message',
            text: 'Error in loading data. Please check your internet connection!'
          });
          console.log(err);
          this.loading = false;
      });
    },
    getData(){
      this.loading = true;
      axios({
          url : this.baseURL + "dashboard/analytics/areaWise",
          headers : {
              authorization : store.state.token
          },
          method : "POST",
          data : {
            date : this.selected.date,
            startDate : this.selected.startDate,
            endDate : this.selected.endDate,
            areaType : this.selected.areaType,
            sourceType : this.selected.sourceType,
            c : this.selected.circle,
            d : this.selected.division,
            r : this.selected.range,
            b : this.selected.block
          }
      })
      .then(res => {
          if(res.data.status)
          {                
            this.sightingData  = res.data.data.sightings;  
            this.sightingTypeData = res.data.data.sightingType;
            this.animalWiseData = res.data.data.animalWise;                  
          }
          else{
            this.$notify({
              group: 'notification',
              type : 'warn',
              title: 'Something went wrong',
              text: 'Error in loading data. Something went wrong!'
            });
          }
          this.loading = false;
      })
      .catch(err => {
          this.$notify({
            group: 'notification',
            type : 'warn',
            title: 'Important message',
            text: 'Error in loading data. Please check your internet connection!'
          });
          console.log(err);
          this.loading = false;
      });
    },
  },
  
}
</script>
